import * as Y from 'yjs'
import { hashJson } from '@basehub/utils/hash'

export const buildYDocFromState = (state: string) => {
  const ydoc = new Y.Doc()

  if (state) {
    // convert string to unit8array:
    const unit8array = Buffer.from(state, 'base64')
    // apply update to ydoc
    try {
      Y.applyUpdateV2(ydoc, unit8array)
    } catch (error) {
      Y.applyUpdate(ydoc, unit8array)
    }
  }

  return ydoc
}

export const emptyTipTapContent = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: [],
    },
  ],
}

export const emptyTipTapContentHash = () => {
  return hashJson(emptyTipTapContent)
}
